import loadable from '@loadable/component';

// 懒加载组件

const LicenseManagement = loadable(() => import('./licenseManagement/LicenseManagement'));
const DocumentLicenseManagement = loadable(() => import('./documentLicenseManagement/DocumentLicenseManagement'));
const FactoryManagement = loadable(() => import('./factoryManagement/FactoryManagement'));
const AgentManagement = loadable(() => import('./agentManagement/AgentManagement'));
const ProductManagement = loadable(() => import('./productManagement/ProductManagement'));
const DeliveryDocumentLicenseManagement = loadable(() => import('./deliveryDocumentLicenseManagement/DeliveryDocumentLicenseManagement'));
const ProductDocumentLicenseManagement = loadable(() => import('./productLicenseView/productDocLicManage/DocumentLicenseManagement'));
const NewProductDocumentLicenseManagement = loadable(() => import('./productLicenseView/newProductDocLicManage/DocumentLicenseManagement'));
const ContractQuery = loadable(() => import('./contractQuery/ContractQuery'));

export const subRoutes = [
  {
    path: '/LicenseManagement',
    component: LicenseManagement
  },
  {
    path: '/DocumentLicenseManagement',
    component: DocumentLicenseManagement
  },
  {
    path: '/FactoryManagement',
    component: FactoryManagement
  },
  {
    path: '/ProductManagement',
    component: ProductManagement
  },
  {
    path: '/AgentManagement',
    component: AgentManagement
  },
  {
    path: '/DeliveryDocumentLicenseManagement',
    component: DeliveryDocumentLicenseManagement
  },
  {
    path: '/ProductDocumentLicenseManagement',
    component: ProductDocumentLicenseManagement
  },
  {
    path: '/NewProductDocumentLicenseManagement',
    component: NewProductDocumentLicenseManagement
  },
  {
    path: '/ContractQuery',
    component: ContractQuery
  }
];
